import { render, staticRenderFns } from "./GroupwiseMortalDetails.vue?vue&type=template&id=15ca66c8&scoped=true"
import script from "./GroupwiseMortalDetails.vue?vue&type=script&lang=js"
export * from "./GroupwiseMortalDetails.vue?vue&type=script&lang=js"
import style0 from "./GroupwiseMortalDetails.vue?vue&type=style&index=0&id=15ca66c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca66c8",
  null
  
)

export default component.exports